module.exports = __webpack_public_path__ + "img/nose.fcf1ff84.svg";